import Hamburger from "./Hamburger"
import './Nav.css'
import { useState } from 'react'
import { Outlet, Link } from 'react-router-dom'
import Banner from './Banner';
import useGetConfig from '../hooks/useGetConfig';
import { useTheme } from '../utils/ThemeContext';

import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PaletteIcon from '@mui/icons-material/Palette';

export default function Nav() {
    const [hamburgerOpen, setHamburgerOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const { data: configData } = useGetConfig();
    const { theme, themeName, setThemeName } = useTheme();

    const showTournament = (() => {
        if (!configData?.records) return false;
        const item = configData.records.find(c => c.field === 'showTournamentPage');
        return item?.paramValue === '1' || item?.paramValue === 1;
    })();

    const toggleHamburger = () => {
        setHamburgerOpen(!hamburgerOpen);
    };

    const handlePickerOpen = (e) => setAnchorEl(e.currentTarget);
    const handlePickerClose = () => setAnchorEl(null);

    return (
        <div>
            <>
            <div className="navigation">
                <Banner onClick={toggleHamburger} />
                <ul>
                    <li style={{paddingBottom: "6px"}}><Link to="/" style={{textDecoration: "none", color: theme.navText}} onClick={toggleHamburger}>Home</Link></li>
                    <li style={{paddingBottom: "6px"}}><Link to="/results" style={{textDecoration: "none", color: theme.navText}} onClick={toggleHamburger}>Results</Link></li>
                    <li style={{paddingBottom: "6px"}}><Link to="/standings" style={{textDecoration: "none", color: theme.navText}} onClick={toggleHamburger}>Standings</Link></li>
                    <li style={{paddingBottom: "6px"}}><Link to="/skins" style={{textDecoration: "none", color: theme.navText}} onClick={toggleHamburger}>Skins</Link></li>
                    <li style={{paddingBottom: "6px"}}><Link to="/members" style={{textDecoration: "none", color: theme.navText}} onClick={toggleHamburger}>Members</Link></li>
                    <li style={{paddingBottom: "6px"}}><Link to="/rules" style={{textDecoration: "none", color: theme.navText}} onClick={toggleHamburger}>Rules</Link></li>
                    <li style={{paddingBottom: "6px"}}><Link to="/score" style={{textDecoration: "none", color: theme.navText}} onClick={toggleHamburger}>Submit Score</Link></li>
                    {showTournament && (
                        <li><Link to="/tournament" style={{textDecoration: "none", color: theme.navText}} onClick={toggleHamburger}>Tournament</Link></li>
                    )}
                </ul>
                <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div className="palette-btn">
                        <IconButton onClick={handlePickerOpen} size="small" style={{ color: theme.navText, padding: 0 }}>
                            <PaletteIcon />
                        </IconButton>
                    </div>
                    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handlePickerClose}>
                        {[
                            { key: 'default', label: 'Default' },
                            { key: 'dark', label: 'Dark' },
                            { key: 'strangerthings', label: 'Stranger Things' },
                            { key: 'canada', label: 'Canada' },
                            { key: 'masters', label: 'The Masters' },
                            // { key: 'starwars', label: 'Star Wars' },
                        ].map(({ key, label }) => (
                            <MenuItem
                                key={key}
                                selected={key === themeName}
                                onClick={() => { setThemeName(key); handlePickerClose(); }}
                            >
                                {label}
                            </MenuItem>
                        ))}
                    </Menu>
                    <div className="hamburger-btn" onClick={toggleHamburger}>
                        <Hamburger isOpen={hamburgerOpen} />
                    </div>
                </div>
                <style jsx="true">{`
                    .navigation {
                        width: 100%;
                        height: 100px;
                        background-color: ${theme.navBg};
                        display: flex;
                        align-items: center;
                        position: relative;
                        padding: 0 16px;
                        box-sizing: border-box;
                    }

                    .navigation ul {
                        display: flex;
                        flex-wrap: wrap;
                        align-items: center;
                        list-style: none;
                        margin: 0;
                        padding: 0 24px;
                        gap: 4px 10px;
                    }

                    @media (max-width: 600px) {
                        .navigation ul {
                            display: ${hamburgerOpen ? 'flex' : 'none'};
                            flex-direction: column;
                            gap: 0;
                            position: absolute;
                            top: 100px;
                            left: 0;
                            right: 0;
                            background: linear-gradient(to bottom, ${theme.navBgMobile} 0%, ${theme.navBgMobileBottom} 100%);
                            backdrop-filter: none;
                            -webkit-backdrop-filter: none;
                            z-index: 998;
                            padding: 12px 16px;
                            box-sizing: border-box;
                            margin: 0;
                            border-top: none;
                            box-shadow: none;
                        }
                    }

                    .navigation ul li {
                        list-style-type: none;
                        padding-right: 10px;
                    }

                    .text-link {
                        text-decoration: none;
                    }

                    .hamburger-btn {
                        cursor: pointer;
                    }
                `}</style>
             </div>

            <Outlet />
            </>
        </div>
    );
}
